<script setup>
const props = defineProps({
    items: {
        type: Array,
        default: []
    },
    initialValue: {
        type: Array,
        default: null
    }
})

const emits = defineEmits(['updateFilter'])
const updateFilter = (values) => {
    const valuesS = values.length ? values.map((item) => item.id) : []
    emits('updateFilter', valuesS)
}

const filterValues = ref([])

onMounted(() => {
    if (props.initialValue) {
        filterValues.value = props.items.filter((item) => {
            return [...props.initialValue].includes(`${item.id}`)
        })
    }
})

watch(filterValues, (newValue) => {
    updateFilter(newValue)
})
</script>
<template>
    <div class="single-filter-ui">
        <v-btn-toggle
            v-model="filterValues"
            multiple
            divided
            density="compact"
            class="border filter-toggle-buttons"
        >
            <v-btn
                size="small"
                v-for="(item, index) in items"
                :key="index"
                :value="item"
                class="text-capitalize"
            >
                {{ item.name }}
            </v-btn>
            <v-btn
                size="small"
                @click="filterValues = items"
                :active="filterValues.length === items.length"
                class="text-capitalize"
            >
                {{ $t('all') }}
            </v-btn>
        </v-btn-toggle>
    </div>
</template>
<style scoped>
.filter-toggle-buttons {
    /* overflow: scroll; */
}

.filter-toggle-buttons {
    flex-wrap: wrap !important;
    display: inline !important;
}

.filter-toggle-buttons button.v-btn {
    flex-wrap: wrap;
    display: inline-block;
    min-height: 34px;
    border: 1px solid #ccc !important;
}
</style>
